<template>
  <div>
    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>
    <div v-if="photos_not_enabled" class="mt-3" >
      <div class="font-icon-detail">
            <span style="font-size: 3em">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
        <h4 class="mt-3">This feature is unavailable.</h4>
        <base-button type="primary" v-if="hasPermissions('billing_view')"
                     v-on:click="goToBilling()" class="mt-3">Go to billing</base-button>
        <p style="font-size: medium" v-else>Contact a site administrator to update billing.</p>
      </div>
    </div>

    <div v-if="!photos_not_enabled">
      <h5 class="info-text">
        Would you like to take a player photo now?
      </h5>
      <div class="row justify-content-center mt-5">
        <div class="col-sm-7">
          <div class="row">
            <div class="col">
              <!-- Photo container with overlay support -->
              <div class="text-center">
                <!-- Placeholder when no photo taken yet -->
                <div v-if="!hasPhoto" class="photo-placeholder gt-empty">
                  <i class="tim-icons icon-camera-18" style="font-size: 4em; color: #9A9A9A;"></i>
                  <p class="mt-3" style="color: #9A9A9A;">No photo taken yet</p>
                </div>
                <!-- Actual photo container -->
                <div v-else style="position: relative; display: inline-block;" id="photoEditorContainer">
                  <div v-if="isProcessing"
                       style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;
                        background-color: rgba(0, 0, 0, 0.7); z-index: 10;
                        display: flex; align-items: center; justify-content: center;
                        border-radius: 0px;">
                    <div style="text-align: center; color: white;">
                      <svg class="custom-spinner" viewBox="0 0 50 50" style="width: 36px; height: 36px; margin-bottom: 10px;">
                      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                      </svg>
                      <div style="font-size: 14px;">{{ processingText }}</div>
                    </div>
                  </div>
                  <img v-if="model.overlay_url" id="photoImg" :src="model.overlay_url" @load="updateCanvasSize"
                       crossorigin="anonymous" style="max-width: 100%; border-radius: 0px;" alt="Player photo"/>
                  <img v-else id="photoImg" :src="model.uploaded_image" @load="updateCanvasSize"
                       crossorigin="anonymous" style="max-width: 100%; border-radius: 0px;" alt="Player photo"/>
                  <canvas id="photoCanvas" style="position: absolute; top: 0; left: 0;"></canvas>
                </div>
              </div>

              <div class="mt-3" style="display: flex; gap: 4px; align-items: center;">
                <span v-if="!hasPhoto" class="btn btn-primary btn-simple btn-file" style="flex: 1;" @click="onTakePhotoClick">
                  <i class="tim-icons icon-camera-18"></i> Take a photo
                  <input v-if="!useLiveCamera && isAndroid14" type="file"
                         @change="takePhoto()"/>
                  <input v-else-if="!useLiveCamera" type="file"
                         accept="image/*"
                         @change="takePhoto()"/>
                </span>
                <span v-if="hasPhoto" class="btn btn-sm btn-success btn-link btn-file text-white" style="padding: 5px;" @click="onTakePhotoClick">
                  <i class="tim-icons icon-refresh-02"></i>
                  <input v-if="!useLiveCamera && isAndroid14" type="file"
                         @change="takePhoto()"/>
                  <input v-else-if="!useLiveCamera" type="file"
                         accept="image/*"
                         @change="takePhoto()"/>
                </span>
                <span v-if="hasPhoto" class="btn btn-sm btn-danger btn-link text-white" style="padding: 5px;"
                      @click="deletePhoto()">
                  <i class="tim-icons icon-trash-simple"></i>
                </span>
              </div>

              <div class="row mt-3" v-if="hasPhoto">
                <div class="col">
                  <el-switch active-color="#e14eca"
                             v-model="email_to_group"
                             @change="onEmailToGroupToggle" />
                  <label> &nbsp; Email to group</label>
                </div>
              </div>

              <!-- Overlay: same row as the Photos page card, select plus bare icon buttons -->
              <div class="ps-overlay-row" v-if="overlays.length > 0 && hasPhoto">
                <base-input label="Overlay" class="ps-overlay-field mb-0">
                  <el-select
                    v-model="selectedOverlay"
                    class="select-primary"
                    name="overlay"
                    placeholder="No overlay applied"
                    :disabled="isProcessing"
                    v-on:change="onOverlayPicked"
                    value-key="id"
                  >
                    <el-option
                      v-for="o in overlays"
                      class="select-primary"
                      :label="o.name + ' [' + o.aspect_ratio +']'"
                      :value="{id: o.id, name: o.name, layers: o.layers,
                    aspect_ratio: o.aspect_ratio, reference_height: o.reference_height,
                    reference_width: o.reference_width, crop_to_overlay: o.crop_to_overlay}"
                      :key="o.id"
                    ></el-option>
                  </el-select>
                </base-input>
                <div class="ps-overlay-actions" v-if="selectedOverlay">
                  <el-tooltip content="Adjust overlay" effect="light" :open-delay="300" placement="top">
                    <base-button class="like btn-link ps-overlay-action" size="sm" icon :disabled="isProcessing" @click="openAdjust">
                      <i class="tim-icons text-white icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip content="Clear overlay" effect="light" :open-delay="300" placement="top">
                    <base-button class="like btn-link ps-overlay-action" size="sm" icon :disabled="isProcessing" @click="onClearPicked">
                      <i class="tim-icons text-white icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  
  <base-alert-dialog :show="alertDialog.show"
                     :title="alertDialog.title"
                     :message="alertDialog.message"
                     :variant="alertDialog.variant"
                     :show-cancel="alertDialog.showCancel"
                     :confirm-text="alertDialog.confirmText"
                     :cancel-text="alertDialog.cancelText"
                     :confirm-variant="alertDialog.confirmVariant"
                     @confirm="resolveAlert(true)"
                     @cancel="resolveAlert(false)" />
  <adjust-overlay-drawer
    :show="adjustShow"
    :photo-url="model.uploaded_image"
    :overlay="selectedOverlay || null"
    :override="model.overlay_layers"
    :resolve-text="content => processDynamicContent(content)"
    @close="adjustShow = false"
    @apply="onAdjustApply" />
  <adjust-overlay-drawer
    :show="!!pendingPhoto"
    pending
    :photos="pendingPhoto ? [{ uploaded_image: pendingPhoto.url, overlay_id: pendingPhoto.overlayId, overlay_layers: null }] : null"
    :photo-index="0"
    :overlays="overlays"
    :resolve-text="content => processDynamicContent(content)"
    @close="cancelPending"
    @retake="retakePending"
    @use="usePending" />
  <live-camera-capture
    :show="liveCamera.show"
    :overlays="overlays"
    :overlay-id="liveCamera.overlayId"
    :resolve-text="content => processDynamicContent(content)"
    @close="closeLiveCamera"
    @use-native="useNativeCamera"
    @capture="onLiveCapture" />
  <input ref="nativeInput" type="file" :accept="isAndroid14 ? undefined : 'image/*'" style="display: none" @change="takePhoto()">
</div>
</template>

<script>
import {API_LOCATION} from "@/api-config";
import {formatCustomTime} from "@/util/customTime";
import axios from "axios";
import {Auth} from "aws-amplify";
import _ from "lodash";
import { bakeOverlay, preparePhotoCanvas } from '@/util/overlayRenderer';
import { effectiveLayers, cropsToOverlay } from '@/util/overlayGeometry';
import AdjustOverlayDrawer from '@/components/Photos/AdjustOverlayDrawer.vue';
import LiveCameraCapture from '@/components/Photos/LiveCameraCapture.vue';
import { Switch } from 'element-ui';

// JPEG quality for canvas exports (overlay bake and download). Quality 1
// disables quantization and produced files 3 to 4 times larger than the phone
// original (a 5 MB photo became an 18 MB composite), which then failed to
// email. 0.95 is the top of the professional band (above what the phone itself
// captured at) and keeps the file near the source size.
const OVERLAY_EXPORT_QUALITY = 0.95

export default {
  name: "PhotoStep",
  props: {
    gameInstanceId: { type: [String, Number], default: null }
  },
  components: {
    [Switch.name]: Switch,
    AdjustOverlayDrawer,
    LiveCameraCapture
  },
  data() {
    return {
      alertDialog: { show: false, title: '', message: '', variant: 'warning', showCancel: false, confirmText: 'OK', cancelText: 'Cancel', confirmVariant: 'primary' },
      alertResolve: null,
      draftPopulated: false,
      loading: false,
      photos_not_enabled: false,
      uploadUrl: '',
      file: '',
      layout: 'landscape',
      userAgent: navigator.userAgent,
      photo_id: '',
      photo_link_id: '',
      email_to_group: false,
      overlays: [],
      selectedOverlay: '',
      isProcessing: false,
      processingText: 'Processing overlay...',
      adjustShow: false,
      // Review before saving (Photo settings toggle): the taken file waits here until Use photo.
      review_before_save: false,
      pendingPhoto: null,
      // Camera choice (Photo settings): 'native' opens the device camera, 'live' the in page camera view.
      camera_mode: 'native',
      liveCamera: { show: false, overlayId: null },
      model: {
        uploaded_image: 'https://console.offthecouch.io/img/placeholder.jpg',
        overlay_url: '',
        overlay_id: null,
        overlay_layers: null
      }
    }
  },
  computed: {
    isAndroid14() {
      return navigator.userAgent.match(/Android/i) !== null;
    },
    liveCameraSupported() {
      return typeof navigator !== 'undefined' && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) && window.isSecureContext
    },
    useLiveCamera() {
      return this.camera_mode === 'live' && this.liveCameraSupported
    },
    hasPhoto() {
      return this.model.uploaded_image &&
             this.model.uploaded_image !== 'https://console.offthecouch.io/img/placeholder.jpg' &&
             this.model.uploaded_image !== '';
    }
  },
  methods: {
    // Promise-based wrapper around the shared base-alert-dialog. Resolves true
    // on confirm, false on cancel or dismiss.
    showAlert(opts){
      if(this.alertResolve){
        this.alertResolve(false)
      }
      this.alertDialog = {
        show: true,
        title: opts.title || '',
        message: opts.message || '',
        variant: opts.variant || 'warning',
        showCancel: opts.showCancel === true,
        confirmText: opts.confirmText || 'OK',
        cancelText: opts.cancelText || 'Cancel',
        confirmVariant: opts.confirmVariant || (opts.showCancel && opts.variant === 'warning' ? 'danger' : 'primary')
      }
      return new Promise(resolve => { this.alertResolve = resolve })
    },
    resolveAlert(value){
      this.alertDialog.show = false
      const resolve = this.alertResolve
      this.alertResolve = null
      if(resolve) resolve(value)
    },
    async onEmailToGroupToggle(val){
      // When enabling group email, warn (allow override) if any confirmed participant opted out of photo sharing.
      if(!val){
        return
      }
      let preNotes = JSON.parse(localStorage.getItem(this.draftKey('preNotes')))
      let recipients = (preNotes && preNotes.users) ? preNotes.users.filter(u => u.confirmed) : []
      let optedOut = recipients.filter(u => u && u.opted_out_photo_sharing)
      if(optedOut.length === 0){
        return
      }
      let isSingle = recipients.length === 1
      let names = optedOut
        .map(u => `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.email)
        .join(', ')
      let confirmed = await this.showAlert({
        title: isSingle ? 'Customer opted out' : 'Some participants opted out',
        message: isSingle
          ? `This customer opted out of having their photo shared. Only send if you have their consent.`
          : `${names} opted out of having their photo shared. Only send if you have their consent.`,
        variant: 'warning',
        showCancel: true,
        confirmText: 'Send anyway',
        cancelText: 'Cancel'
      })
      if(confirmed !== true){
        this.email_to_group = false
      }
    },
    draftKey(key) {
      if (!this.gameInstanceId) {
        console.warn('draftKey called with no gameInstanceId for key:', key)
        return key + '_NONE'
      }
      return key + '_' + this.gameInstanceId
    },
    goToBilling(){
      this.$router.push('/settings/billing')
    },
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    async validate() {
      this.$emit('on-validated', true, this.model);
      return true;
    },
    async setPhoto () {
      let photoData = {
        ...this.model,
        email_to_group: this.email_to_group,
        photo_id: this.photo_id,
        photo_link_id: this.photo_link_id
      }
      localStorage.setItem(this.draftKey('photo'), JSON.stringify(photoData))

      //save draft
      let companyId = localStorage.getItem('companyId')
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let url = API_LOCATION + 'companies/' + companyId
        + '/games/instances/' + this.gameInstanceId + '/drafts'

      // this.convertTime()
      let data = {
        photo: this.model.uploaded_image
      }
      axios.put(url, data, config)
        .then(response => {
          let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
          draft.photo = data.photo

          localStorage.setItem(this.draftKey('draft'), JSON.stringify(draft))
        })
        .catch(err => {
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    handleUpload(){
      let file = event.target.files[0];
      if (file && !file.type.match('image.*')) {
        this.showAlert({ title: 'Error', message: 'You must upload an image', variant: 'danger' })
        return
      }
      this.uploaded_image = URL.createObjectURL(file);
      this.file = file
      this.$emit('change', file);
    },
    async saveFile() {
      this.uploadUrl = await this.getSignedURL(this.file)
      let uploaded = await this.uploadFile(this.file)
    },
    async getSignedURL (file) {
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let url = API_LOCATION + 'upload/photos'

      let payload = {
        filePath: file.name,
        contentType: file.type
      }

      return new Promise ( function(resolve, reject) {
        axios.post(url, payload, config)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            console.error(err)
            reject(err)
          })
      })
    },
    uploadFile (file) {
      let url = this.uploadUrl
      let config = { headers: {
          'Content-Type': file.type
        }}

      let payload = file
      return new Promise ( function(resolve, reject) {
        axios.put(url, payload, config)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            console.error(err)
            reject(err)
          })
      })
    },
    saveToLocalDraft() {
      let photoData = {
        ...this.model,
        email_to_group: this.email_to_group,
        photo_id: this.photo_id,
        photo_link_id: this.photo_link_id
      }
      localStorage.setItem(this.draftKey('photo'), JSON.stringify(photoData))

      let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
      if (draft) {
        draft.photo = this.model.uploaded_image
        draft.url = this.model.uploaded_image
        localStorage.setItem(this.draftKey('draft'), JSON.stringify(draft))
      }
    },
    resetState(){
      this.draftPopulated = false
      this.model.uploaded_image = 'https://console.offthecouch.io/img/placeholder.jpg'
      this.model.overlay_url = ''
      this.model.overlay_id = null
      this.model.overlay_layers = null
      this.photo_id = ''
      this.photo_link_id = ''
      this.email_to_group = false
      this.selectedOverlay = ''
    },
    populateDraft(){
      this.draftPopulated = true
      let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
      if(draft){
        // Check both url (localStorage-only field) and photo (backend field)
        if(draft.url){
          this.model.uploaded_image = draft.url
        } else if(draft.photo){
          this.model.uploaded_image = draft.photo
        }
      }

      let photo = JSON.parse(localStorage.getItem(this.draftKey('photo')))
      if(photo){
        // Restore image from photo localStorage if draft didn't have it
        if(photo.uploaded_image
          && photo.uploaded_image !== 'https://console.offthecouch.io/img/placeholder.jpg'
          && (!this.model.uploaded_image
              || this.model.uploaded_image === 'https://console.offthecouch.io/img/placeholder.jpg')){
          this.model.uploaded_image = photo.uploaded_image
        }
        if(photo.email_to_group !== undefined){
          this.email_to_group = photo.email_to_group
        }
        if(photo.photo_id){
          this.photo_id = photo.photo_id
        }
        if(photo.photo_link_id){
          this.photo_link_id = photo.photo_link_id
        }
        if(photo.overlay_id){
          this.model.overlay_id = photo.overlay_id
          this.model.overlay_url = photo.overlay_url || ''
          this.model.overlay_layers = photo.overlay_layers || null
        }
      }
      // A draft resumed on another device has no photo record in this browser;
      // the draft row carries the photo and its overlay state.
      if(draft && !this.photo_id && draft.photo_id){
        this.photo_id = draft.photo_id
        if(draft.overlay_id){
          this.model.overlay_id = draft.overlay_id
          this.model.overlay_url = draft.overlay_url || ''
          this.model.overlay_layers = draft.overlay_layers || null
        }
      }
      this.syncSelectedOverlay()
    },
    // Point the Select overlay dropdown at the overlay on the photo once both are known.
    syncSelectedOverlay(){
      if(!this.model.overlay_id || !this.overlays.length) return
      const match = this.overlays.find(o => o.id === this.model.overlay_id)
      if(match){
        this.selectedOverlay = {
          id: match.id, name: match.name, layers: match.layers,
          aspect_ratio: match.aspect_ratio, reference_height: match.reference_height,
          reference_width: match.reference_width, crop_to_overlay: match.crop_to_overlay
        }
      }
    },
    async getLayout(){
      let img = new Image()
      img.src = URL.createObjectURL(this.file)


      return new Promise((resolve, reject) => {
        img.onload = () => resolve(img);
        img.onerror = reject;
      });

    },
    async takePhoto(){
      this.handleUpload()
      if(!this.file){return}
      if (this.review_before_save) {
        // window.event is gone after the first await, so grab the input now.
        const inputEl = event.target
        let bookingInfo = JSON.parse(localStorage.getItem(this.draftKey('bookingInfo')))
        let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
        const gameId = bookingInfo?.booking?.game_id
        const match = gameId && this.overlays.length > 0 ? await this.findMatchingOverlay(gameId, draft?.completed, this.uploaded_image) : null
        this.pendingPhoto = { url: this.uploaded_image, file: this.file, inputEl, overlayId: match ? match.id : null }
        return
      }
      await this.uploadPhoto()
    },
    // Live overlay camera ---------------------------------------------------
    async onTakePhotoClick() {
      // With the system camera the file input inside the button handles the click.
      if (!this.useLiveCamera) return
      let bookingInfo = JSON.parse(localStorage.getItem(this.draftKey('bookingInfo')))
      let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
      const gameId = bookingInfo?.booking?.game_id
      const match = gameId && this.overlays.length > 0 ? await this.findMatchingOverlay(gameId, draft?.completed, '') : null
      this.liveCamera = { show: true, overlayId: match ? match.id : null }
    },
    closeLiveCamera() {
      this.liveCamera.show = false
    },
    useNativeCamera() {
      this.closeLiveCamera()
      this.$nextTick(() => this.$refs.nativeInput && this.$refs.nativeInput.click())
    },
    async onLiveCapture({ file, overlayId }) {
      this.closeLiveCamera()
      const overlay = overlayId ? this.overlays.find(o => o.id === overlayId) || null : null
      this.file = file
      this.uploaded_image = URL.createObjectURL(file)
      if (this.review_before_save) {
        this.pendingPhoto = { url: this.uploaded_image, file, inputEl: null, overlayId: overlay ? overlay.id : null, source: 'live' }
        return
      }
      // The live view already showed the overlay, so the choice made there stands in for auto apply.
      await this.uploadPhoto({ overlay, overlayLayers: null })
    },
    // Review drawer (pending mode) -------------------------------------------
    cancelPending() {
      if (!this.pendingPhoto) return
      URL.revokeObjectURL(this.pendingPhoto.url)
      if (this.pendingPhoto.inputEl) this.pendingPhoto.inputEl.value = ''
      this.pendingPhoto = null
      this.file = ''
      this.uploaded_image = ''
    },
    retakePending() {
      const pending = this.pendingPhoto
      this.cancelPending()
      if (!pending) return
      if (pending.source === 'live') {
        this.liveCamera = { show: true, overlayId: pending.overlayId || null }
      } else if (pending.inputEl) {
        pending.inputEl.click()
      }
    },
    async usePending({ overlay, overlayLayers }) {
      const pending = this.pendingPhoto
      if (!pending) return
      this.pendingPhoto = null
      // The object URL stays valid until uploadPhoto swaps model.uploaded_image for the S3 URL.
      await this.uploadPhoto({ overlay, overlayLayers })
      URL.revokeObjectURL(pending.url)
      if (pending.inputEl) pending.inputEl.value = ''
    },
    // review: { overlay, overlayLayers } from the review drawer; when present it
    // replaces auto apply, because staff already decided in the review.
    async uploadPhoto(review = null){
      let t = new Date().toLocaleString( 'sv' );
      // Feedback first: scrim and local preview before any decode or network.
      // Decoding a 24 MP image (getLayout) takes seconds on a tablet and used
      // to run silently before the spinner even appeared; it only measures the
      // aspect ratio, so it runs in parallel with the upload instead.
      this.processingText = 'Uploading photo...'
      this.isProcessing = true
      this.model.uploaded_image = this.uploaded_image
      try {
        const [, layout] = await Promise.all([this.saveFile(), this.getLayout()])
        if(parseFloat(layout.width / layout.height).toFixed(2) == 0.75 ) {
          this.layout = 'portrait'
        }
      } catch (err) {
        this.isProcessing = false
        this.showAlert({ title: 'Error', message: 'Failed to upload photo. Please try again.', variant: 'danger' })
        return
      }
      if (!this.uploadUrl) {
        this.isProcessing = false
        return
      }
      var token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      // Get booking slot ID from bookingInfo
      let bookingSlotId = ''
      let bookingInfo = JSON.parse(localStorage.getItem(this.draftKey('bookingInfo')))
      if(bookingInfo && bookingInfo.booking && bookingInfo.booking.id){
        bookingSlotId = bookingInfo.booking.id
      }

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/photos?bsId=' + bookingSlotId + '&t=' + t

      let data = {
        uploaded_image:  this.uploadUrl.split("?")[0],
        layout: this.layout
      }

      this.model.uploaded_image =  this.uploadUrl.split("?")[0]

      axios.post(url, data, config)
        .then(async response => {
          this.file = ''
          this.uploadUrl = ''
          this.photo_link_id = response.data.photo_link_id
          this.photo_id = response.data.photo_id

          if (review) {
            if (review.overlay) {
              this.selectedOverlay = {
                id: review.overlay.id, name: review.overlay.name, layers: review.overlay.layers,
                aspect_ratio: review.overlay.aspect_ratio, reference_height: review.overlay.reference_height,
                reference_width: review.overlay.reference_width, crop_to_overlay: review.overlay.crop_to_overlay
              }
              // saveOverlay drops an adjustment that belongs to another overlay, so the id moves first.
              this.model.overlay_id = review.overlay.id
              this.model.overlay_layers = review.overlayLayers || null
              await this.saveOverlay()
            } else {
              this.isProcessing = false
            }
          } else if (this.overlays.length > 0) {
            // Auto-apply overlay if conditions match
            await this.autoApplyOverlay()
          } else {
            this.isProcessing = false
          }
        }).catch((err) => {
        console.log(err)
        this.isProcessing = false
        if(err.response && err.response.status == 401){
          this.$router.push('/forbidden')
        } else {
          this.showAlert({
            title: 'Something went wrong!',
            variant: 'danger',
            confirmText: 'Try again'
          })
        }
      })
    },
    async deletePhoto() {
      const result = await this.showAlert({
        title: 'Delete photo?',
        message: 'This action cannot be undone.',
        variant: 'warning',
        showCancel: true,
        confirmText: 'Delete'
      })

      if (result !== true) return

      if (this.photo_id) {
        try {
          let token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let groupId = JSON.parse(localStorage.getItem('group')).id
          let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/photos/' + this.photo_id

          await axios.delete(url, config)
        } catch (err) {
          console.log(err)
          if (err.response && err.response.status === 401) {
            this.$router.push('/forbidden')
            return
          }
          this.showAlert({ title: 'Error', message: 'Failed to delete photo', variant: 'danger' })
          return
        }
      }

      // Clear photo-related properties
      this.model.uploaded_image = ''
      this.model.overlay_url = ''
      this.model.overlay_id = null
      this.model.overlay_layers = null
      this.photo_id = ''
      this.photo_link_id = ''
      this.email_to_group = false
      this.selectedOverlay = ''

      // Clear localStorage photo data
      localStorage.removeItem(this.draftKey('photo'))

      // Update draft
      let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
      if (draft) {
        draft.photo = ''
        draft.url = ''
        localStorage.setItem(this.draftKey('draft'), JSON.stringify(draft))
      }
    },
    // Overlay methods
    parseAspectRatio(ratioString) {
      if (!ratioString) return null
      const parts = ratioString.split(':')
      if (parts.length !== 2) return null
      return parseFloat(parts[0]) / parseFloat(parts[1])
    },
    async findMatchingOverlay(gameId, completed, photoUrl) {
      const matchingOverlays = this.overlays.filter(overlay => {
        if (!overlay.applied_by_default) return false

        let gameDefaults = overlay.game_defaults
        if (typeof gameDefaults === 'string') {
          gameDefaults = JSON.parse(gameDefaults)
        }
        if (!gameDefaults || gameDefaults.length === 0) return false

        const gameDefault = gameDefaults.find(gd => gd.game_id === gameId)
        if (!gameDefault) return false

        const condition = gameDefault.apply_condition
        const isCompleted = completed === true || completed === 1 || completed === 'true'
        const isNotCompleted = completed === false || completed === 0 || completed === 'false'

        if (condition === 'always') return true
        if (condition === 'escaped' && isCompleted) return true
        if (condition === 'not_escaped' && isNotCompleted) return true
        if (completed === null || completed === undefined) {
          return condition === 'always'
        }

        return false
      })

      if (matchingOverlays.length === 0) return null
      if (matchingOverlays.length === 1) return matchingOverlays[0]

      // Multiple matches - prefer closest aspect ratio
      if (!photoUrl) return matchingOverlays[0]
      try {
        const img = await this.loadImage(photoUrl)
        const photoRatio = img.naturalWidth / img.naturalHeight

        let bestMatch = matchingOverlays[0]
        let smallestDiff = Infinity

        for (const overlay of matchingOverlays) {
          const overlayRatio = this.parseAspectRatio(overlay.aspect_ratio)
          if (overlayRatio !== null) {
            const diff = Math.abs(photoRatio - overlayRatio)
            if (diff < smallestDiff) {
              smallestDiff = diff
              bestMatch = overlay
            }
          }
        }

        return bestMatch
      } catch (err) {
        console.error('Could not load image for aspect ratio detection:', err)
        return matchingOverlays[0]
      }
    },
    async autoApplyOverlay() {
      // Get game info from localStorage
      let bookingInfo = JSON.parse(localStorage.getItem(this.draftKey('bookingInfo')))
      let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))

      const gameId = bookingInfo?.booking?.game_id
      const completed = draft?.completed

      if (!gameId) {
        this.isProcessing = false
        return
      }

      const matchingOverlay = await this.findMatchingOverlay(gameId, completed, this.model.uploaded_image)
      if (!matchingOverlay) {
        this.isProcessing = false
        return
      }
      if (this.model.overlay_id) {
        this.isProcessing = false
        return
      }

      // Set the overlay and apply it
      this.selectedOverlay = {
        id: matchingOverlay.id,
        name: matchingOverlay.name,
        layers: matchingOverlay.layers,
        aspect_ratio: matchingOverlay.aspect_ratio,
        reference_height: matchingOverlay.reference_height,
        reference_width: matchingOverlay.reference_width,
        crop_to_overlay: matchingOverlay.crop_to_overlay
      }
      await this.saveOverlay()
    },
    async getOverlays(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let groupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/photo-overlays'

      axios.get(url, config)
        .then(response => {
          this.overlays = response.data.overlays
          this.review_before_save = response.data.review_before_save === true
          this.camera_mode = response.data.camera_mode === 'live' ? 'live' : 'native'
          this.syncSelectedOverlay()
        }).catch((err) => {
        console.log(err)
      })
    },
    updateCanvasSize() {
      let underlyingImage = document.getElementById('photoImg')
      if (!underlyingImage) return

      let imgHeight = underlyingImage.height
      let imgWidth = underlyingImage.width

      const canvas = document.getElementById('photoCanvas')
      if (!canvas) return

      let ctx = canvas.getContext('2d')
      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = 'high'
      canvas.height = imgHeight
      canvas.width = imgWidth

      let scale = window.devicePixelRatio
      let originalWidth = canvas.offsetWidth
      let originalHeight = canvas.offsetHeight

      canvas.width = originalWidth * scale
      canvas.height = originalHeight * scale

      canvas.style.width = originalWidth + 'px'
      canvas.style.height = originalHeight + 'px'

      ctx.scale(scale, scale)
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = () => resolve(img)
        img.onerror = () => reject(new Error(`Failed to load image at ${url}`))
        img.src = url
      })
    },
    async preloadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = () => resolve(img)
        img.onerror = () => reject(new Error(`Failed to preload image: ${url}`))
        img.src = url
      })
    },
    async processDynamicContent(content) {
      // Get booking info for dynamic content
      let bookingInfo = JSON.parse(localStorage.getItem(this.draftKey('bookingInfo')))
      let draft = JSON.parse(localStorage.getItem(this.draftKey('draft')))
      let preNotes = JSON.parse(localStorage.getItem(this.draftKey('preNotes')))
      let postNotes = JSON.parse(localStorage.getItem(this.draftKey('postNotes')))
      let group = JSON.parse(localStorage.getItem('group'))
      let company = JSON.parse(localStorage.getItem('company'))

      if (content.includes('[Team Name]')) {
        let teamName = preNotes?.team || ''
        content = content.replaceAll('[Team Name]', teamName)
      }

      if (content.includes('[Company Name]')) {
        content = content.replaceAll('[Company Name]', company?.name || '')
      }

      if (content.includes('[Location Name]')) {
        content = content.replaceAll('[Location Name]', group?.name || '')
      }

      if (content.includes('[Event Name]') || content.includes('[Game Name]')) {
        // [Game Name] is the legacy spelling of [Event Name]; overlays saved before the rename still carry it.
        // The draft's game_name is the customer facing name (drafts endpoint selects g.name);
        // the booking row's game_name is the staff facing internal name, kept only as a fallback.
        let gameName = draft?.game_name || bookingInfo?.booking?.game_name || ''
        content = content.replaceAll('[Event Name]', gameName).replaceAll('[Game Name]', gameName)
      }

      if (content.includes('[Completion Time]')) {
        let completionTime = postNotes?.completion_time || ''
        content = content.replaceAll('[Completion Time]', completionTime ? completionTime + ' minutes' : '')
      }

      if (content.includes('[Custom Time]')) {
        // formatCustomTime renders MM:SS (HH:MM:SS when needed) and blanks all-zero/empty
        content = content.replaceAll('[Custom Time]', formatCustomTime(postNotes?.custom_time))
      }

      if (content.includes('[Time Remaining]')) {
        let timeRemaining = postNotes?.time_remaining || ''
        content = content.replaceAll('[Time Remaining]', timeRemaining ? timeRemaining + ' minutes' : '')
      }

      if (content.includes('[Number Of Hints]')) {
        let hints = postNotes?.number_of_hints || 0
        content = content.replaceAll('[Number Of Hints]', hints + ' hints')
      }

      return content
    },
    // The dropdown is the overlay state. Picking a different overlay on an
    // adjusted photo confirms first, because the adjustment belongs to the old one.
    async onOverlayPicked() {
      if (!this.selectedOverlay) {
        if (this.model.overlay_id) await this.onClearPicked()
        return
      }
      if (this.model.overlay_layers && this.model.overlay_id !== this.selectedOverlay.id) {
        const ok = await this.showAlert({
          title: 'Discard adjustments?',
          message: 'This photo has adjusted layers. Switching overlays starts from the new overlay as designed.',
          variant: 'warning',
          showCancel: true,
          confirmText: 'Switch',
          confirmVariant: 'danger'
        })
        if (ok !== true) {
          this.syncSelectedOverlay()
          return
        }
        this.model.overlay_layers = null
      }
      await this.saveOverlay()
    },
    async onClearPicked() {
      if (this.model.overlay_layers) {
        const ok = await this.showAlert({
          title: 'Discard adjustments?',
          message: 'This photo has adjusted layers. Clearing the overlay removes them.',
          variant: 'warning',
          showCancel: true,
          confirmText: 'Clear',
          confirmVariant: 'danger'
        })
        if (ok !== true) {
          this.syncSelectedOverlay()
          return
        }
      }
      await this.clearOverlay()
    },
    openAdjust() {
      if (!this.selectedOverlay || !this.photo_id) return
      this.adjustShow = true
    },
    async onAdjustApply({ overlayLayers }) {
      this.adjustShow = false
      this.model.overlay_layers = overlayLayers
      await this.saveOverlay()
    },
    async saveOverlay() {
      if (!this.selectedOverlay) return

      this.processingText = 'Processing overlay...'
      this.isProcessing = true

      try {
        // Always bake from the untouched original. Baking on top of a previous
        // composite stacked overlays and added a JPEG generation on every re-apply.
        const baseImage = await this.loadImage(this.model.uploaded_image)
        // An overlay with crop on keeps only the centered area with its aspect ratio.
        const { canvas: compositeCanvas, ctx, width: photoWidth, height: photoHeight } = preparePhotoCanvas(baseImage, {
          aspectRatio: this.selectedOverlay.aspect_ratio,
          crop: cropsToOverlay(this.selectedOverlay),
        })

        // A per photo adjustment belongs to one overlay; a different overlay starts from its template.
        if (this.model.overlay_layers && this.model.overlay_id !== this.selectedOverlay.id) {
          this.model.overlay_layers = null
        }
        const eff = effectiveLayers(this.selectedOverlay, this.model.overlay_layers)

        // Shared renderer: uniform fit, centered, same code the editor previews with.
        await bakeOverlay({
          ctx,
          layers: eff.layers,
          aspectRatio: this.selectedOverlay.aspect_ratio,
          referenceWidth: eff.referenceWidth,
          referenceHeight: eff.referenceHeight,
          photoWidth,
          photoHeight,
          resolveText: (content) => this.processDynamicContent(content),
        })

        // Convert canvas to blob and upload
        compositeCanvas.toBlob(async (blob) => {
          try {
            this.file = new File([blob], 'composite_overlay.jpg', { type: 'image/jpeg' })

            await this.saveFile()
            if (!this.uploadUrl) {
              this.showAlert({ title: 'Error', message: 'Failed to upload photo. Please try again.', variant: 'danger' })
              return
            }

            let token = await this.getAuthToken()
            let config = {headers: {Authorization: token}}
            let companyId = localStorage.getItem('companyId')
            let groupId = JSON.parse(localStorage.getItem('group')).id
            let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/photos/' + this.photo_id + '/overlay'

            this.model.overlay_url = this.uploadUrl.split("?")[0]
            this.model.overlay_id = this.selectedOverlay.id

            let data = {
              overlay_url: this.uploadUrl.split("?")[0],
              overlay_id: this.selectedOverlay.id,
              overlay_layers: this.model.overlay_layers || null
            }

            await axios.post(url, data, config)

            const newImageUrl = this.model.overlay_url + '?t=' + Date.now()
            await this.preloadImage(newImageUrl)

            const img = document.getElementById('photoImg')
            if (img) {
              img.src = newImageUrl
            }

            this.isProcessing = false
            this.file = ''
            this.uploadUrl = ''
          } catch (err) {
            console.log(err)
            this.isProcessing = false
            this.showAlert({ title: 'Error', message: 'Failed to save overlay', variant: 'danger' })
          }
        }, 'image/jpeg', OVERLAY_EXPORT_QUALITY)
      } catch (error) {
        console.error('Error in saveOverlay:', error)
        this.isProcessing = false
        this.showAlert({ title: 'Error', message: 'Failed to create overlay', variant: 'danger' })
      }
    },
    async clearOverlay() {
      const canvas = document.getElementById('photoCanvas')
      if (canvas) {
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
      }

      this.selectedOverlay = ""
      this.model.overlay_id = null
      this.model.overlay_url = ""
      this.model.overlay_layers = null

      this.processingText = 'Clearing overlay...'
      this.isProcessing = true

      try {
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let groupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/photos/' + this.photo_id + '/overlay'

        let data = {
          overlay_url: "",
          overlay_id: null
        }

        await axios.post(url, data, config)

        // Preload the original image
        const newImageUrl = this.model.uploaded_image + '?t=' + Date.now()
        await this.preloadImage(newImageUrl)

        const img = document.getElementById('photoImg')
        if (img) {
          img.src = newImageUrl
        }

        this.isProcessing = false
        this.file = ''
        this.uploadUrl = ''
      } catch (err) {
        console.log(err)
        this.isProcessing = false
        this.showAlert({ title: 'Error', message: 'Failed to clear overlay', variant: 'danger' })
      }
    },
  },
  mounted(){
    if(!(_.find(JSON.parse(localStorage.getItem('features')), {id: 5}))){
      this.photos_not_enabled = true
    } else {
      this.photos_not_enabled = false
      this.getOverlays()
    }
  }
}
</script>

<style scoped>
.ps-overlay-row {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  margin-top: 16px;
}
.ps-overlay-field { flex: 1; min-width: 0; margin-right: 6px; }
.ps-overlay-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  height: calc(2.25rem + 2px);
}
.ps-overlay-action { margin: 0; }
.ps-overlay-action i { opacity: 0.7; }
.ps-overlay-action:hover i { opacity: 1; }
.game-button{
  width: 100%;
}
canvas {
  image-rendering: optimizeQuality;
}
/* Photo placeholder — visual base from gt-empty, override padding */
.photo-placeholder {
  padding: 60px 40px;
}
</style>
